import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { combineLatest, Observable } from "rxjs";
import { Injectable } from "@angular/core";
import {
  AgreementSigningStatus,
  SessionStorageKey,
  SessionStorageState,
  RouteHelper,
  parseNumber,
  SsoAccountFacade
} from "common";
import { map, take } from "rxjs/operators";
import { EntityFacade } from "../entity/domain/+state/entity.facade";

@Injectable({
  providedIn: "root",
})
export class LocAgreementSignedGuard implements CanActivate {
  constructor(
    private router: Router,
    private ssoAccountFacade: SsoAccountFacade,
    private entityFacade: EntityFacade
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (SessionStorageState.get(SessionStorageKey.AccountSetupViewed)) {
      return true;
    }

    const companyId = parseNumber(RouteHelper.getQueryParamValueByName(route, "companyId"));
    return combineLatest([
      this.entityFacade.getEntity$(companyId),
      this.ssoAccountFacade.getCurrentSsoAccount$(),
    ]).pipe(
      take(1),
      map(([entity, ssoAccount]) => {
        const selectedEntityId = entity?.id;
        const pendingLoanAgreement = ssoAccount?.loans?.find((loan) =>
          (
            loan.agreementState?.entityId === selectedEntityId &&
            loan.agreementState?.agreementSigningStatus === AgreementSigningStatus.PendingCurrentUser
          ) ||
          (
            loan.renewalApplication?.entityId === selectedEntityId &&
            loan.renewalApplication?.agreementSigningStatus === AgreementSigningStatus.PendingCurrentUser
          )
        );

        if (pendingLoanAgreement) {
          this.router.navigate([
            `account/${pendingLoanAgreement.loanId}/setup/sign-agreement`,
          ]);
          return false;
        }

        return true;
      })
    );
  }
}
